import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RouteError, RouteNotFound } from "@/components/route-boundaries";

export const Route = createFileRoute("/_authenticated/admin/bousala")({
  head: () => ({
    meta: [{ title: "إدارة بوصلة د. سارة" }, { name: "robots", content: "noindex" }],
  }),
  errorComponent: RouteError,
  notFoundComponent: RouteNotFound,
  component: BousalaAdminLayout,
});

function BousalaAdminLayout() {
  return (
    <div dir="rtl" className="space-y-5">
      <Outlet />
    </div>
  );
}
